import { useEffect } from "react";

import {
    ConfluenceTemplateCollectionDetailsRelayPageTemplate,
    ConfluenceTemplateCollectionDetailsRelayPageTemplateProps
} from "@/templates/software/confluence/templates/confluence-templates-page/src/relay/confluence-template-collection-details-relay-page.template";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export type ConfluenceTemplateCollectionDetailsRelayPageProps =
    ConfluenceTemplateCollectionDetailsRelayPageTemplateProps;

export const ConfluenceTemplateCollectionDetailsRelayPage = ({
    queryRef
}: ConfluenceTemplateCollectionDetailsRelayPageProps) => {
    useEffect(() => {
        checkFeatureFlagGate(
            featureFlags.cpapiwdConfluenceTemplateCollectionDetails
        );
    }, []);

    return (
        <ConfluenceTemplateCollectionDetailsRelayPageTemplate
            queryRef={queryRef}
        />
    );
};
